/**
 * Alpine.js Directive: x-track
 *
 * This directive pushes tracking events to `window.dataLayer` based on an array of event objects 
 * stored in a referenced `<template>`. It can be used by adding `x-track` to a `<template>` tag.
 * 
 * -- Usage --
 * <template x-track>
 *     [{ "event": "cmp_event", "name": "article_listing" }, { "event": "cmp_event", "name": "page_load" }]
 * </template>
 *
 * Behavior:
 * 1. The `<template>` content can be either an array of objects representing `dataLayer` events 
 *    or a single event object.
 *
 * Example Output:
 * window.dataLayer.push({ event: "cmp_event", name: "article_listing" });
 * window.dataLayer.push({ event: "cmp_event", name: "page_load" });
 */

import Alpine from "alpinejs";
import { trackEvent } from "../../modules/track/trackEvent";

Alpine.directive("track", (el, {}, { evaluate }) => {
    try {
        if (el.tagName === "TEMPLATE") {
            const trackEvents = evaluate(el.innerHTML);
            if (Array.isArray(trackEvents)) {
                trackEvents.map(trackObj => {
                    trackEvent(trackObj);
                });
            } else if (typeof trackEvents === "object") {
                trackEvent(trackEvents);
            }
        }
    }
    catch(e) {
        console.error("Track Failed", e);
    }
});